/**
 * Created by Ning Jiang on 11/11/2019.
 */

import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {DeadwoodSoundConfig} from "../DeadwoodSoundConfig";
import {ShootingGameView} from "./ShootingGameView";

export class ShootingGameController extends BaseController {
    private static TOTAL_SHOOT:number = 2;

    private _view:ShootingGameView;
    private _shotLeft:number = ShootingGameController.TOTAL_SHOOT;

    constructor() {
        super();
        this._view = new ShootingGameView((e?:PIXI.InteractionEvent) => this.onClick(e));
        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, ScreenEvent.GAME_START, (event:GameEvent) => this.onGameStart());
    }

    private onGameStart() {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, ScreenEvent.PICK_AND_CLICK_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, SpinEvent.IDLE, (event:GameEvent) => this.onEnableGame());
        this.onEnableGame();
    }

    private onBeforeSpinStart():void {
        this.onDisableGame();
        this._shotLeft = ShootingGameController.TOTAL_SHOOT;
    }

    private onEnableGame():void {
        // Logger.logDev("------------SHOOTING GAME ENABLED!");
        this._view.enabled = true;
    }

    private onDisableGame():void {
        // Logger.logDev("------------SHOOTING GAME DISABLED!");
        this._view.enabled = false;
        this._view.clear();
    }

    private onClick(e?:PIXI.InteractionEvent):void {
        if (e){
            if(this._shotLeft > 0) {
                this._view.shotAt(e.data.getLocalPosition(this._view.parent));
                SlotGame.sound.playEffect((<any>DeadwoodSoundConfig.instance)[`SHOOT_WINDOW_${this._shotLeft}`]);
                this._shotLeft--;
            } else {
                SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.SHOOT_WINDOW_EMPTY);
            }

            e.stopPropagation();
        }
    }
}